import type { RootState } from '@src/store/store';
import type { Draft, PayloadAction } from '@reduxjs/toolkit';
import type { AdminUser, AdminUsersState } from 'src/store/types/admin-users-types';

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import api, { endpoints } from 'src/lib/axios';

export const initialState: AdminUsersState = {
  list: {
    users: [],
    status: 'idle',
    error: '',
  },
};

// ====== Thunks (typed) ======
export const loadAdminUsers = createAsyncThunk<AdminUser[], void>(
  'admin-users/loadAdminUsers',
  async () => {
    const res = await api.get<AdminUser[]>(endpoints.admin.adminUsers);
    return res.data;
  }
);

const slice = createSlice({
  name: 'admin-users',
  initialState,
  reducers: {
    setAdminUsers(
      adminUsersState: Draft<AdminUsersState>,
      action: PayloadAction<{ adminUsers: AdminUser[] }>
    ) {
      adminUsersState.list = {
        users: action.payload.adminUsers,
        status: 'succeeded',
        error: '',
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadAdminUsers.pending, (state: Draft<AdminUsersState>) => {
        state.list.status = 'loading';
        state.list.error = '';
      })
      .addCase(loadAdminUsers.fulfilled, (state: Draft<AdminUsersState>, action) => {
        state.list.status = 'succeeded';
        state.list.users = action.payload;
      })
      .addCase(loadAdminUsers.rejected, (state: Draft<AdminUsersState>, action) => {
        state.list.status = 'failed';
        state.list.error = action.error?.message ?? 'Failed to load adminUsers';
      });
  },
});

export const { setAdminUsers } = slice.actions;
export default slice.reducer;

export const selectAdminUsersList = (s: RootState) => s.adminUser.list.users;
export const selectAdminUsersStatus = (s: RootState) => s.adminUser.list.status;
